<template>
  <teleport to="body" v-if="props.modelValue">
    <div
      class="backdrop"
      @click="onClick"
      :style="{
        zIndex: zIndex - 1,
      }"
    />
  </teleport>
</template>

<script setup>
  import { ref, watch } from 'vue';
  import { useBackdropStore } from '@/stores/backdrop';

  const emit = defineEmits(['close']);

  const props = defineProps({
    modelValue: {
      required: true,
      type: null,
    },
  });

  const backdropStore = useBackdropStore();
  const zIndex = ref(backdropStore.zIndex);

  watch(() => props.modelValue, (value) => {
    if (value) {
      backdropStore.increaseIndex();
      zIndex.value = backdropStore.zIndex;
    }
  });

  function onClick() {
    if (props.modelValue) {
      emit('close');
    }
  }
</script>
